<template>
  <div class="api-container">
    <navigation arr-theme="black" :sticky="false"
                :theme="{ background: 'transparent', color: '#fff' }" customClickEvent @click="navigateToHome" v-if="!isBottomSheet"
    >
    <div slot="right" class="back" @click="navigateToRiver">去主页</div></navigation>
    <div :class="['api-container-header',{isBottomSheet}]">
      <img class="banner" :src="bannerUrl" v-if="(bannerUrl && bannerUrl.length > 0)" @click="jumpToKingCardPage" data-sensors-click data-sensors-exposure-event-name="Element_Exposure"  data-sensors-exposure-property-caseId="SKC_M" >
      <div class="tips" v-else></div>
      <div class="recommend"><span>{{isBottomSheet ? "专属下款产品" : "为您推荐"}}</span></div>
      <p class="txt">您的资质符合以下持牌产品要求，可一键申请，
      同时申请通过率更高</p>
    </div>
    <div class="content">
      <!-- <div class="title">
        <span class="main">专属产品</span>
        <span class="percent">99%</span>
        <span class="exp">用户借款成功</span>
      </div> -->
      <div class="list">
        <div
          :class="['item',{active: item.active}]"
          v-for="(item,index) in list"
          :key="index"
          @click="active(item,index)"
          :data-sensors-exposure-property-product_code="item.configId"
          :data-sensors-exposure-property-pageType="pageType"
          :data-sensors-exposure-property-element_positon="position"
          data-sensors-exposure-property-product_type="diversion"
          data-sensors-exposure-event-name="Diversion_Exposure"
        >
          <div class="l-top">
            <img :src="item.icon" alt="logo">
            <div class="lt-middle">
              <span>{{ item.productName }}</span>
              <p>{{item.productDesc}}</p>
            </div>
            <div class="lt-r"><span>{{item.loanCounts}}</span>人已借款</div>
          </div>
          <div class="l-bottom">
            <div class="i-item">
              <span>额度高达 (元) </span>
              <p class="amount"> {{ item.configLimit | currency }}</p>
            </div>
            <div class="i-item">
              <span>年化利率</span>
              <p >{{ item.minPrice }}%-{{ item.maxPrice }}%</p>
            </div>
            <div class="i-item">
              <span>借款期限 </span>
              <p >{{ item.minTerms }}-{{ item.terms }}个月</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="api-footer">
      <nd-button
        class="button"
        @click="getJoinAgreement"
        :disabled="!isBottomSheet && !canAppaly"
        :loading="loading"
      >一键申请</nd-button>
      <p>请在点击「一键申请」前，仔细阅读<a @click="apiProtocolList"> 《产品相关协议》《个人信息使用授权书》</a></p>
    </div>

    <van-popup
      v-model="authenticationVisible"
      round
      position="bottom"
      class="api-popup"
    >
      <div class="api-popup-top">
        <span class="cancle" @click="authenticationVisible=false">取消</span>
      </div>
      <div class="api-popup-main ">
        <div v-html ="agreementDetail.joinStatus"></div>
      </div>
      <div class="api-popup-foot">
        <nd-button class="popup-foot-btn" @click="apply" :loading="loading || applayLoading">确认</nd-button>
      </div>
    </van-popup>


  </div>
</template>
<script>
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { mapActions } from 'vuex'
import {
  judgeClientSystem
} from '@/assets/utils'
import { setKey } from '../../../../assets/utils'
export default {
  data () {
    return {
      applayLoading: false,
      authenticationVisible: false,
      origin: window.location.origin,
      loading: false,
      list: [],
      agreementDetail: {},
      bannerUrl: '',
      isPop: false
    }
  },
  props: {
    isBottomSheet: {
      type: Boolean,
      default: false
    },
    parentPageType: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'product_list'
    }
  },
  async mounted () {
    const pageType = this.pageType
    await Promise.all([this.getBanner(pageType), this.apiApplyList(pageType)])
    this.$bus.$emit('ready')
  },
  computed: {
    canAppaly () {
      return this.list.some(item => item.active)
    },
    isWithDraw () {
      return window.location.pathname.includes('withdraw')
    },
    pageType () {
      return this.isBottomSheet ? this.parentPageType : this.getParams().pageType
    }
  },
  watch: {
    list: {
      immediate: true,
      handler (val) {
        if (val && val.length) {
          const configIds = val.map(i => i.configId)
          setKey('configIds', configIds)
        }
      }
    }
  },

  methods: {
    ...mapActions('apiDiversion', ['batchApplyX', 'creditApply', 'joinAgreement']),
    ...mapActions('user', ['apiListBannerX', 'apiApplyListX', 'protocolShow']),
    async getBanner (pageType) {
      const { success, data } = await this.apiListBannerX({ pageType })
      if (success && data) {
        this.bannerUrl = data.image
      }
    },
    async apiApplyList (pageType) {
      const { success, data } = await this.apiApplyListX({
        pageType
      })
      if (success && data) {
        if (success && data) {
          const list = data.configs || []
          const productCode = []


          this.list = list.map(i => {
            productCode.push(i.configId)
            return {
              ...i,
              active: true
            }
          })
          this.$sensors.track('Results_Page_View', { page_status: this.result, pageType: this.pageType, product_code: productCode.join(',') })
        }
      }
    },
    navigateToHome () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.replace('/')
      }
    },
    IframeLoaded () {
      this.$nextTick(() => {
        this.$refs['authIframe'].contentWindow.postMessage({
          type: 'setFontSize',
          value: document.documentElement.style.fontSize
        }, '*')
      })
    },
    active (item, index) {
      const { active } = item
      this.$set(this.list, index, { ...item, active: !active })
    },
    async apply () {
      // 上报设备信息 如果不成功则阻断
      this.loading = true
      const { data } = await this.sendDataForThird()
      this.loading = false
      if (!data.success) {
        return
      }

      /**
        针对n（n=提交授信的API产品）个API产品进行授信时，拉取运营系统配置n个API产品所需信息字段进行补充
        3.1 缺失实名或者基础信息
        点击，跳转API产品一键申请_授信流程
        3.2、信息完善
        3.2.1点击，针对n=1（n=提交授信的API产品）个API产品进行授信时调用第三方接口，跳转对应授信结果页
        3.2.2点击，针对n>1（n=提交授信的API产品）个API产品进行授信时调用第三方接口，跳转 导流主页-已申请列表 页面
        3.3、相关协议
        点击 跳转相关协议列表，具体协议读取n个API产品第三方协议接口
       */

      const configIds = []
      this.list.forEach(item => {
        if (item.active) {
          configIds.push(item.configId)
          this.$sensors.track('Diversion_Click', { product_type: 'diversion', page_status: this.step, element_positon: this.isPop ? 'product_pop' : this.position, product_code: item.configId })
        }
      })
      setKey('configIds', configIds)
      this.applayLoading = true
      if (configIds.length > 1) {
        const { success, data } = await this.batchApplyX({ configIds })
        this.applayLoading = false
        if (success && data) {
          // 优先去基本资料 然后再人脸 由于这里后端做了处理 faceStatus=flase表示人脸未完成 基本资料已完成
          // 在都未完成的情况 status 是false  faceStatus是true
          if (!data.faceStatus) {
            return this.$router.replace(`/authentication/face?redirectUrl=/river/diversion?tabActive=1`)
          }

          if (!data.status) {
            return this.$router.replace({
              path: '/authentication/api-base?stepType=ALL'
            })
          }

          this.$router.replace('/river/diversion?tabActive=1')
        }
      } else {
        // 如果是单个的 单独调一个接口去获取applyNo
        const res = await this.creditApply({
          configIds
        })
        this.applayLoading = false
        if (res.success) {
          if (!res.data.faceStatus) {
            return this.$router.replace(`/authentication/face?redirectUrl=/authentication/api-result`)
          }

          if (!res.data.status) {
            return this.$router.replace({
              path: '/authentication/api-base?stepType=ALL'
            })
          }

          this.$router.replace({
            path: '/authentication/api-result',
            query: {
              applyNo: res.data.applyNo
            }
          })
        }
      }
    },
    navigateToRiver () {
      this.$router.replace('/river/diversion')
    },
    async getJoinAgreement () {
      const configIds = []
      this.agreementDetail = {}
      this.list
        .filter(element => element.active)
        .forEach(item => {
          this.$sensors.track('Withdraw_Element_Click', { product_type: 'diversion', product_code: item.configId })
          configIds.push(item.configId)
        })

      // 底部弹出框且未选中任何产品
      if (this.isBottomSheet && configIds.length < 1) {
        const maxCount = Math.min(3, this.list.length)
        this.$emit('showListPop', this.list.slice(0, maxCount))
        return
      }
      this.getProtocols(configIds)
    },
    apiProtocolList () {
      const configIds = []
      this.agreementDetail = {}
      this.list.forEach(item => {
        if (item.active) {
          configIds.push(item.configId)
        }
      })
      if (configIds.length > 0) {
        this.$router.push({ path: '/authentication/api-protocol', query: { configIds: configIds } })
      } else {
        this.$message('请勾选产品')
      }
    },
    async receiveApplyAction (items) {
      const configIds = []
      this.agreementDetail = {}
      this.isPop = true
      this.list = items.map(item => {
        this.$sensors.track('Withdraw_Element_Click', { product_type: 'diversion', product_code: item.configId })
        configIds.push(item.configId)
        return {
          ...item,
          active: true
        }
      })
      this.getProtocols(configIds)
    },
    async getProtocols (configIds) {
      // 获取是否有弹窗开关
      this.loading = true
      const res = await this.protocolShow()
      this.loading = false

      if (res.success && res.data && res.data.show) {
        const { success, data } = await this.joinAgreement({ configIds: configIds, busiType: 'CREDIT' })
        if (success) {
          this.agreementDetail = data || {}
          this.authenticationVisible = true
        }
      } else {
        this.apply()
      }
    }
  }
}
</script>
<style lang="less" src="../css/popup.less" scoped></style>
@import "../../../../assets/less/mixin.less";

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.api-container {
  padding-bottom: 250px;
  .iframe {
    height: 638px;
    width: 100%;
    html {
        width: 100%;
    }
  }
  .btn-wrapper {
    position: fixed;
    background: white;
    height: 162px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 620px;
    border-radius: 0 0 30px 30px;
    transform: translateY(-20px);

    .btn {
      width: 500px;
    }
  }
  .back {
    font-size: 28px;
    color: #666666;
    padding: 0 30px;
    text-decoration: underline;
  }
  .api-container-header {
    padding: 70px 60px 0 ;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .banner {
      width: 670px;
      height: 200px;
    }
    .tips{
      width:648px;
      height:100px;
      background: url(./images/img_weitongguo.png) no-repeat;
      background-size: 100% 100%;
    }
    .txt {
      font-size: 28px;
      color: #666666;
      text-align: center;
      margin-top: 25px;
    }
    .recommend{
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 49px;
      span {
        margin: 0px 27px;
      }
      &::after,&::before{
        content: "";
        width: 180px;
        height: 0px;
        border-top: 1px solid #ddd;
      }
    }
    &.isBottomSheet {
      padding: 0px 60px 0px;
    }
  }
  .content {
    margin-top: 20px;
    .title {
      display: flex;
      align-items: center;
      padding-left: 62px;
      margin-bottom: 20px;
      .main {
        font-size: 34px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .percent {
        background: #FF4633;
        border-radius: 8px;
        color: #FFFFFF;
        height: 34px;
        line-height: 34px;
        padding: 0 10px;
        font-size: 24px;
        margin:0 10px
      }
    }

    .list {
      display: flex;
      flex-direction: column;
      align-items: center;
      .item {
        width: 670px;
        background: #FAFAFA;
        border-radius: 20px;
        border: 1px solid #DDDDDD;
        overflow: hidden;
        padding: 23px 57px;
        margin-bottom: 20px;
        position: relative;
        &:after{
          content: "";
          width:66px;
          height:66px;
          position: absolute;
          bottom: 0;right: 0;
          background: url(./images/icon_huigou.png) no-repeat;
          background-size: 100% 100%;
        }
        &.active {
          border-color: #FF4633;
          &:after{
            background-image: url(./images/icon_honggou.png)
          }
        }
        .l-top {
          display: flex;
          align-items: center;
          img{
            width: 54px;
            height: 56px;
            border-radius: 10px;
            margin-right: 6px;
          }
          .lt-middle {
            flex:1;
            display: flex;
            flex-direction: column;
            span {
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #333333;
            }
            p {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
            }
          }
          .lt-r{
            span {
              color: #FF4633;
            }
          }
        }
        .l-bottom {
          display: flex;
          margin-top: 35px;
          justify-content: space-between;
          padding-right: 30px;
          .i-item {
            display: flex;
            flex-direction: column;
            span {
              color: #999999;
              font-size: 24px;
            }
            p {
              font-size: 24px;
            }
            p.amount {
              font-size: 40px;
              font-family: DIN-Medium, DIN;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  .api-footer {
    position: fixed;
    bottom:0;
    width: 100%;
    height: 230px;
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.04);
    justify-content: center;
    align-items: center;
    p {
      font-size: 24px;
      color: #999999;
      padding: 0 40px;
      margin-top: 25px;
    }
    a {
      color: #8EB2D8;
    }
  }
}

</style>